import { Component, Inject, OnInit } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';

import { Temporal } from '@js-temporal/polyfill';
import * as _ from 'lodash';
import { PointagePause } from 'src/app/domain/RH/pointage-pause';
import { PreventDoubleClickDirective } from '../../directive/prevent-double-click.directive';
import { MatButtonModule } from '@angular/material/button';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-pointage-box',
    templateUrl: './pointage-box.html',
    styleUrl: './pointage-box.scss',
    standalone: true,
    imports: [MatDialogModule, MatFormFieldModule, MatInputModule, NgxMaterialTimepickerModule, MatButtonModule, PreventDoubleClickDirective]
})
export class PointageBoxDialog implements OnInit {

    public Model: PointagePause = new PointagePause();
    public interventionTimeDebut!: string;
    public interventionTimeFin!: string;

    Debut: Date = new Date();
    Fin: Date = new Date();

    constructor(
        public dialogRef: MatDialogRef<PointageBoxDialog>,
        @Inject(MAT_DIALOG_DATA) public data: PointagePause) {

        this.Model.Debut = Temporal.Now.plainDateTimeISO();
        this.Model.Fin = Temporal.Now.plainDateTimeISO();
    }

    ngOnInit() { }

    canSave() {
        return this.interventionTimeDebut && this.interventionTimeFin && Temporal.PlainDateTime.compare(this.Model.Debut , this.Model.Fin) < 0;
    }

    timeSetDebut(event: string) {
        const time = event.split(':');

        this.Debut = new Date(this.Debut);
        this.Debut.setHours(Number(time[0]), Number(time[1]));
        this.Model.Debut = Temporal.PlainDateTime.from({year: this.Debut.getFullYear(), day: this.Debut.getDate(), month: this.Debut.getMonth() + 1, hour: this.Debut.getHours(), minute: this.Debut.getMinutes()});
        this.setTimeDebut();
    }

    setTimeDebut() {
        this.interventionTimeDebut = `${this.Debut.getHours()}:${this.Debut.getMinutes()}`;
    }

    timeSetFin(event: string) {
        const time = event.split(':');

        this.Fin = new Date(this.Fin);
        this.Fin.setHours(Number(time[0]), Number(time[1]));
        this.Model.Fin = Temporal.PlainDateTime.from({year: this.Fin.getFullYear(), day: this.Fin.getDate(), month: this.Fin.getMonth() + 1, hour: this.Fin.getHours(), minute: this.Fin.getMinutes()});
        this.setTimeFin();
    }

    setTimeFin() {
        this.interventionTimeFin = `${this.Fin.getHours()}:${this.Fin.getMinutes()}`;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        this.dialogRef.close(this.Model);
    }
}
